export enum SocketEvent {
	REGISTER = "register",
	QUIT = "quit",
	NEW_NOTIFICATION = "new-notification",
}

export enum SocketNamespace {
	NOTIFICATIONS = "notifications",
}
